import React from 'react'
import { ContentAttached, ContentAttach } from '@fs/zion-icon'
import { ListItem } from '@fs/zion-ui'

/**
 * Determines which icon to display based on attachment status
 *
 * @param {string|null} attachmentId - The ID of the attachment, if one exists
 * @returns {Function} - Returns ContentAttached icon if attachment exists, otherwise ContentAttach icon
 */
export const getIconByAttachmentStatus = (attachmentId) => {
  return attachmentId ? ContentAttached : ContentAttach
}

/**
 * Generates a test ID for the icon element
 *
 * @param {string} attachmentOrMatch - The ID used for the link button
 * @param {string|null} attachmentId - The ID of the attachment, if one exists
 * @returns {string} - A formatted test ID string for the icon element
 */
export const getIconTestId = (attachmentOrMatch, attachmentId) => {
  return `source-linker-button-${attachmentOrMatch}-${attachmentId ? 'ContentAttached' : 'ContentAttach'}`
}

/**
 * Creates an icon element for displaying attachment status
 *
 * @param {Function} hintStartingIcon - The icon component to display (ContentAttached or ContentAttach)
 * @param {string} attachmentOrMatch - The ID used for the link button
 * @param {string|null} attachmentId - The ID of the attachment, if one exists
 * @returns {JSX.Element} - A ListItem.Icon element with the appropriate icon and test ID
 */
export const getIconElement = (hintStartingIcon, attachmentOrMatch, attachmentId) => {
  return <ListItem.Icon Icon={hintStartingIcon} data-testid={getIconTestId(attachmentOrMatch, attachmentId)} />
}
